import React, { FC } from "react";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { SvgIconProps } from "@mui/material";

export const NotifAlarmIcon: FC<SvgIconProps> = (props) => {
  return <WarningAmberRoundedIcon sx={{ fontSize: 14 }} {...props} />;
};
